import { TOAST_ERRORS_IN_FORM } from 'mk/autogenerated/translations/form.e02f7234fd3a2a647a29d9d3ab6c136e'
import { showErrorToast } from 'mk2/helpers/toasts';
import { getLogger } from 'mk2/logger';
import { actionTypes, FormAction } from 'redux-form';
import { all, takeLatest } from 'redux-saga/effects';

const logger = getLogger('sagas/form');

function* displayToastOnSubmitFailed({ error }: FormAction) {
    if (error) {
        yield showErrorToast(TOAST_ERRORS_IN_FORM);
    }
}

export default function* root() {
    yield all(
        [
        takeLatest(actionTypes.STOP_SUBMIT, displayToastOnSubmitFailed),
    ]);
}
